// @file Regex constants
import { MAX_NAMESPACE_LENGTH } from 'bits/numbers'

const EMAIL_REGEX =
  /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i
const URL_REGEX = /^(https?:\/\/(?:www\.|(?!www))[^\s\.]+\.[^\s]{2,}|www\.[^\s]+\.[^\s]{2,})$/gi
const TEL_REGEX = /^(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?$/g
// Refer to VALID_FORMAT in app/models/namespace.rb
const USERNAME_REGEX = new RegExp(`^(?!.*[_]{2}.*)[a-zA-Z0-9]{1}[a-zA-Z0-9_]{0,${MAX_NAMESPACE_LENGTH - 1}}$`)
const PADLET_DOMAIN_REGEX = /(padlet|padletorg)\.(com|org|io|test|dev)/
const SLIDESHOW_URL_REGEX = new RegExp(
  `(padlet|padletorg).(com|org|io|test|dev)/((?!.*[_]{2}.*)[a-zA-Z0-9]{1}[a-zA-Z0-9_]{0,${
    MAX_NAMESPACE_LENGTH - 1
  }})+/(.*/)+slideshow(/.*)*`,
)

/**
 * Escape RegExp special characters
 * You can also use this to escape a string that is inserted into the middle of a regex, for example, into a character class.
 * Taken from https://github.com/sindresorhus/escape-string-regexp
 * @param str A string that is to be interpreted as regex
 * @returns Sanitized version of the input
 */
function escapeStringRegexp(str: string): string {
  if (typeof str !== 'string') {
    throw new TypeError('Expected a string')
  }

  // Escape characters with special meaning either inside or outside character sets.
  // Use a simple backslash escape when it’s always valid, and a `\xnn` escape when the simpler form would be disallowed by Unicode patterns’ stricter grammar.
  return str.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d')
}

export {
  EMAIL_REGEX,
  URL_REGEX,
  TEL_REGEX,
  USERNAME_REGEX,
  PADLET_DOMAIN_REGEX,
  SLIDESHOW_URL_REGEX,
  escapeStringRegexp,
}
